import {
  GET_LIST_TRAGOP,
  GET_LIST_TRAGOP_SUCCESS,
  GET_LIST_TRAGOP_FAILURE,
} from "./actionTypes";

export const getListTraGop = (dataSearch) => ({
  type: GET_LIST_TRAGOP,
  dataSearch,
});

export const getListTraGopSuccess = (data) => ({
  type: GET_LIST_TRAGOP_SUCCESS,
  payload: data,
});

export const getListTraGopFailure = () => ({
  type: GET_LIST_TRAGOP_FAILURE,
});
